module.exports = __webpack_public_path__ + "img/img5.f4bd67b6.jpg";